// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1awir","toggle":"styles_toggle__uAD1B","preview":"styles_preview__z25T5"};